
import { Observable } from 'rxjs';

type Location = {
    latitude: number,
    longitude: number

}

export const getLocation = () => {
    return new Observable((observer) => {
      navigator.geolocation.getCurrentPosition(
    (position) => { 
        observer.next(position.coords);
        observer.complete()
      }, (err) => {
        observer.error(err);
      },
      { enableHighAccuracy: true } // gerar uma posicao mais exata
    );
})
}
